import { store } from "../redux/store";

let deviceIdCache: string | null = null;

export const getAccessToken = (): string | null => {
    try {
        const authState = store.getState()?.auth;
        if (authState?.accessToken) {
            return authState.accessToken;
        }
        return localStorage.getItem("accessToken");
    } catch (error) {
        return localStorage.getItem("accessToken");
    }
};

export const setAccessToken = (token: string | null): void => {
    try {
        if (token) {
            localStorage.setItem("accessToken", token);
        } else {
            localStorage.removeItem("accessToken");
        }
    } catch (error) {
    }
};

export const setDeviceId = (deviceId: string | null): void => {
    try {
        if (deviceId) {
            localStorage.setItem("deviceId", deviceId);
            deviceIdCache = deviceId;
        } else {
            localStorage.removeItem("deviceId");
            deviceIdCache = null;
        }
    } catch (error) {
    }
};

export const getDeviceId = (): string => {
    if (deviceIdCache) {
        return deviceIdCache;
    }

    try {
        const legacyUuid = localStorage.getItem("uuid");
        if (legacyUuid) {
            localStorage.setItem("deviceId", legacyUuid);
            localStorage.removeItem("uuid");
            deviceIdCache = legacyUuid;
            return legacyUuid;
        }

        const existingDeviceId = localStorage.getItem("deviceId");
        if (existingDeviceId) {
            deviceIdCache = existingDeviceId;
            return existingDeviceId;
        }

        const newDeviceId = crypto.randomUUID();
        localStorage.setItem("deviceId", newDeviceId);
        deviceIdCache = newDeviceId;
        return newDeviceId;
    } catch (error) {
        try {
            const sessionId = sessionStorage.getItem("deviceId");
            if (sessionId) {
                deviceIdCache = sessionId;
                return sessionId;
            }

            const tempId = crypto.randomUUID();
            sessionStorage.setItem("deviceId", tempId);
            deviceIdCache = tempId;
            return tempId;
        } catch (sessionError) {

            if (!deviceIdCache) {
                deviceIdCache = crypto.randomUUID();
            }
            return deviceIdCache;
        }
    }
};
